import { noop } from '@showroomjs/core';
import { useForceUpdateOnSubtreeChange, useIsInViewport } from '@showroomjs/ui';
import * as React from 'react';
import { checkA11y } from './check-a11y';
export const useA11yCheck = (target, onValue) => {
    const { inViewport } = useIsInViewport({
        target,
        init: observerInit,
        disconnectOnEnter: true,
    });
    useForceUpdateOnSubtreeChange(target);
    React.useEffect(() => {
        if (!inViewport) {
            return;
        }
        if (target.current) {
            let isCurrent = true;
            checkA11y(target.current)
                .then((result) => {
                if (isCurrent) {
                    onValue(result);
                }
            })
                .catch(noop);
            return () => {
                isCurrent = false;
            };
        }
    });
};
const observerInit = {
    rootMargin: `20% 20%`,
};
//# sourceMappingURL=use-a11y-check.js.map